export default "__VITE_ASSET__D8D0VLJH__"